import isDevelopmentEnvironment from './isDevEnvironment';
export default function returnIfDev(something) {
    if (isDevelopmentEnvironment()) {
        return something;
    }
    else {
        return null;
    }
}
